import {
  darkTheme,
  lightTheme,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useMemo, type ReactNode } from 'react'
import { WagmiProvider } from 'wagmi'

import { CustomAvatar } from '@/components/customAvatar'
import { useLocalStorage } from '@/context/localstorage-context'
import { config } from '@/wagmi'

export const AppProviders = ({ children }: { children: ReactNode }) => {
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 增加缓存时间
      },
    },
  })

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          locale="en-US"
          avatar={CustomAvatar}
          theme={isdark ? darkTheme() : lightTheme()}
        >
          {children}
          <ReactQueryDevtools initialIsOpen={true} />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
